import React, { useState } from 'react';
import '../styles/MedicalServices.css';
import DoctorsImg from '../assets/images/doctors.png';
import AmbulanceImg from '../assets/images/ambulance.png';
import SurgeryImg from '../assets/images/ip-surgery.png';
import PharmacyImg from '../assets/images/pharmacy.png';
import DialysisImg from '../assets/images/dialysis.png';
import BloodDonorImg from '../assets/images/blood_donor.png';
import DiagnosticsImg from '../assets/images/diagnostics.png';
import LogoBlue from '../assets/images/logo_blue.png';

const MedicalServices = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleServiceClick = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="medical-services">
        <h2 className="services-title">Our Services</h2>
        
        <div className="services-grid">
          {/* Row 1: Ambulance - Full Width */}
          <div className="service-card ambulance-card" onClick={handleServiceClick}>
            <div className="service-content">
              <h3 className="service-title">Ambulance</h3>
              <p className="service-subtitle">Available 24/7</p>
            </div>
            <div className="service-image">
              <img src={AmbulanceImg} alt="Ambulance" />
            </div>
          </div>

          {/* Row 2: Blood Donor (Left) and Doctors (Right) */}
          <div className="service-card blood-donor-card" onClick={handleServiceClick}>
            <div className="service-content">
              <h3 className="service-title">Blood Donor</h3>
              <p className="service-subtitle">Find blood bank</p>
            </div>
            <div className="service-image">
              <img src={BloodDonorImg} alt="Blood Donor" />
            </div>
          </div>

          <div className="service-card doctors-card" onClick={handleServiceClick}>
            <div className="service-content">
              <h3 className="service-title">Doctors</h3>
              <p className="service-subtitle">Find best doctors</p>
            </div>
            <div className="service-image">
              <img src={DoctorsImg} alt="Doctors" />
            </div>
          </div>

          {/* Row 3: Diagnostics - Full Width */}
          <div className="service-card diagnostics-card" onClick={handleServiceClick}>
            <div className="service-content">
              <h3 className="service-title">Diagnostics</h3>
              <p className="service-subtitle">Book Lab test online</p>
              <button className="service-btn" onClick={(e) => { e.stopPropagation(); handleServiceClick(); }}>
                Door Step Service ↗
              </button>
            </div>
            <div className="service-image">
              <img src={DiagnosticsImg} alt="Diagnostics" />
            </div>
          </div>

          {/* Row 4: Dialysis (Left) and Pharmacy (Right) */}
          <div className="service-card dialysis-card" onClick={handleServiceClick}>
            <div className="service-content">
              <h3 className="service-title">Dialysis</h3>
              <p className="service-subtitle">Hussel free process</p>
            </div>
            <div className="service-image">
              <img src={DialysisImg} alt="Dialysis" />
            </div>
          </div>

          <div className="service-card pharmacy-card" onClick={handleServiceClick}>
            <div className="service-content">
              <h3 className="service-title">Pharmacy</h3>
              <p className="service-subtitle">Order Medicines online</p>
            </div>
            <div className="service-image">
              <img src={PharmacyImg} alt="Pharmacy" />
            </div>
          </div>
        </div>
      </div>

      {/* Download App Modal */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="download-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>×</button>
            
            <div className="modal-logo">
              <img src={LogoBlue} alt="App Logo" />
            </div>
            
            <h2 className="modal-title">Download Our App!</h2>
            <p className="modal-subtitle">Only on Play store and App Store</p>
            
            <div className="app-store-buttons">
              <button className="app-store-btn apple-btn">
                <div className="btn-content">
                  <i className="bi bi-apple"></i>
                  <div className="btn-text">
                    <span className="download-text">DOWNLOAD ON THE</span>
                    <span className="store-text">App Store</span>
                  </div>
                </div>
              </button>
              
              <button className="app-store-btn google-btn">
                <div className="btn-content">
                  <i className="bi bi-google-play"></i>
                  <div className="btn-text">
                    <span className="download-text">GET IT ON</span>
                    <span className="store-text">Google Play</span>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MedicalServices;